import { Chip, Tooltip } from '@mui/material';
import React from 'react';

export type EnvironmentChipProps = {
  className?: string;
};

/**
 * Environment Chip Component
 * Displays the current environment (development, staging, etc.) when not in production
 */
const EnvironmentChip = ({ className }: EnvironmentChipProps) => {
  // Only show in non-production environments
  if (process.env.REACT_APP_ENVIRONMENT === 'production') {
    return null;
  }

  const environmentLabel = process.env.REACT_APP_ENVIRONMENT?.toUpperCase() || 'UNKNOWN';

  return (
    <Tooltip title="Este mensaje no se mostrará en producción">
      <Chip
        variant="filled"
        label={`Environment: ${environmentLabel}`}
        sx={{ mx: 2 }}
        color="primary"
        className={className}
      />
    </Tooltip>
  );
};

export default EnvironmentChip;
